<template>
  <TirPmModal
    :is-visible="isVisible"
    title="Внимание: комментарий не отправлен"
    :is-with-back="false"
    @close="cancel"
  >
    <template #footer>
      <TirPmButton
        :size="TirPmButtonSizeEnum.Regular"
        :variant="TirPmButtonVariantEnum.PrimaryState"
        @click="cancel"
      >
        <div style="padding: 0 0.5rem">Отмена</div>
      </TirPmButton>
      <TirPmButton
        :size="TirPmButtonSizeEnum.Regular"
        :variant="TirPmButtonVariantEnum.LinkState"
        @click="confirm"
      >
        <div style="padding: 0 0.688rem">Продолжить</div>
      </TirPmButton>
    </template>
  </TirPmModal>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmModal,
} from "tir-components";

const isVisible = ref(false);

let callback: (confirm: boolean) => void | undefined = undefined;

/**Открыть модальное окно */
const open = async () => {
  return new Promise<boolean>((resolve) => {
    callback = (confirm) => {
      resolve(confirm);
    };
    isVisible.value = true;
  });
};
/**Закрыть модальное окно */
const close = () => {
  callback = undefined;
  isVisible.value = false;
};

/**При выходе */
const cancel = () => {
  callback?.(false);
  close();
};

/**При отмене выхода */
const confirm = () => {
  callback?.(true);
  close();
};

defineExpose({
  open,
});
</script>

<style lang="scss" scoped></style>
